export default __webpack_public_path__ + "static/media/investor2.273b705e.png";